module.exports = __webpack_public_path__ + "img/valve-loop-16.3ecddc49.svg";